export default __webpack_public_path__ + "static/media/youtube-white.f74a6f1f.svg";